import React from "react";

export default function ModalTailwind({ show, onClose, title, children }) {
  if (!show) return null;

  return (
    <>
      {/* Fondo semi-transparente */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-40"
        onClick={onClose} // cierra al hacer click fuera
      />

      {/* Contenedor modal */}
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div
          className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative"
          onClick={(e) => e.stopPropagation()} // evita cierre al hacer click dentro
        >
          <h3 className="text-lg font-semibold mb-4">{title}</h3>
          <div>{children}</div>
        </div>
      </div>
    </>
  );
}
